import React from 'react';

import AccountantCard from 'v3/pages/ShippingCompany/Requests/shared/AccountantCard';

import { useShippingCompany } from '../shared/context';

// Contador que veio da solicitação de cadastro, gravado na transportadora pela aprovação. Só leitura.
// Simples Nacional e início da emissão de contra CT-e ficam editáveis no card "Dados da transportadora".
export default function RequestInfo() {
  const shippingCompany = useShippingCompany();
  const company = shippingCompany.data?.shippingCompanies;

  return (
    <AccountantCard
      name={company?.accountant_name}
      phone={company?.accountant_phone}
      email={company?.accountant_email}
    />
  );
}
